export { formatClass } from './Formatters';



// WEBPACK FOOTER //
// ./src/main/ui/react/shared/helpers/index.js